import axios from 'axios';

const apiCall = axios.create({
  baseURL: window.IdentificationWebsiteGlobalConfig.basePaths.identificationApi,
})

export default apiCall;
